<template>
    <sub-section title="Can you still expect to get what you want?"
                 helpTitle="What to take each year"
                 :helpText="HelpText.incomeAndPotsCharts()">
        <div v-show="chartDataHasLoaded" class="row">
            <ul class="tab-header">
                <li :class="{ 'tab-selected': selectedTabIndex == 0, 'tab-unselected': selectedTabIndex != 0 }">
                    <button role="button"
                            tabindex="0"
                            @click="onTabClick(0)"
                            @keyup.enter="onTabClick(0)"
                            @keyup.space="onTabClick(0)"
                            :aria-label="incomeChartDescription">
                        Income
                    </button>
                </li>
                <li :class="{ 'tab-selected': selectedTabIndex == 1, 'tab-unselected': selectedTabIndex != 1 }">
                    <button role="button"
                            tabindex="0"
                            @click="onTabClick(1)"
                            @keyup.enter="onTabClick(1)"
                            @keyup.space="onTabClick(1)"
                            :aria-label="potsChartDescription">
                        Your Pots
                    </button>
                </li>
            </ul>

            <div class="tab-content">
                <div v-show="selectedTabIndex == 0">
                    <income-charts />
                </div>

                <div v-show="selectedTabIndex == 1">
                    <pots-chart />
                </div>
            </div>
        </div>
    </sub-section>
</template>

<script setup lang="ts">
    import { ref, computed } from "vue";
    import IncomeCharts from "@/guiide/components/charts/IncomeCharts.vue";
    import PotsChart from "@/guiide/components/charts/PotsChart.vue";
    import SubSection from "@/guiide/components/common/SubSection.vue";
    import HelpText from "@/guiide/ts/helpText";
    import { retireeDescriber } from "@/guiide/ts/retireeDescriber";

    const selectedTabIndex = ref(0);

    const chartDataHasLoaded = ref(true);

    const incomeChartDescription = computed<string>(() => "Your income chart. A description of the chart: " + retireeDescriber.getIncomeChartDescription());
    const potsChartDescription = computed<string>(() => "Your pots chart. A description of the chart: " + retireeDescriber.getPotsChartDescription());

    function onTabClick(index: number) {
        selectedTabIndex.value = index;
    }
</script>

<style lang="css" scoped>
    ul.tab-header {
        display: block;
        list-style: none;
        margin: 0 0 0 0;
        padding: 0;
    }

        ul.tab-header > li {
            border: lightgray solid 1px;
            margin: 0;
            display: inline-block;
            margin-right: 0px;
            cursor: pointer;
            color: darkslategray;
            width: 50%;
        }

            ul.tab-header > li.tab-selected {
                border-bottom: 0;
            }

            ul.tab-header > li.tab-unselected {
                background-color: #f7f7f6;
            }

                ul.tab-header > li.tab-unselected:hover {
                    background-color: #fcfcfc;
                }

    li > button {
        all: unset;
        cursor: pointer;
        display: block;
        width: 100%;
        height: 100%;
        padding: 5px 15px;
        box-sizing: border-box;
    }

        li > button:focus-visible {
            outline: 2px solid darkslategrey;
            border-radius: 2px;
        }

    .tab-content {
        padding-top: 45px;
        border: lightgrey solid 1px;
        border-top: 0;
    }
</style>
